import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectManagementContainerComponent } from './containers/project-management-container/project-management-container.component';
import { GmouContainerComponent } from './containers/gmou-container/gmou-container.component';
import { ProjectMonitorContainerComponent } from './containers/project-monitor-container/project-monitor-container.component';
import { ProjectProgressContainerComponent } from './containers/project-progress-container/project-progress-container.component';
import { ProjectReportContainerComponent } from './containers/project-report-container/project-report-container.component';
import { BudgetPerformanceContainerComponent } from './containers/budget-performance-container/budget-performance-container.component';

const routes: Routes = [
  { path: '', component: ProjectManagementContainerComponent },
  { path: 'gmou', component: GmouContainerComponent },
  { path: 'monitor', component: ProjectMonitorContainerComponent },
  { path: 'progress', component: ProjectProgressContainerComponent },
  { path: 'budget-performance', component: BudgetPerformanceContainerComponent },
  { path: 'report', component: ProjectReportContainerComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectManagementRoutingModule {}
